export default {
  machine: [
    {
      colorValue: "yellow",
      color: "#FFA400",
      color_name_en: "Mango Yellow",
      color_name_tc: "芒果黃",
      sku: "GDV2-GB-YE-NE",
    },
    {
      colorValue: "blue",
      color: "#7BE0D3",
      color_name_en: "Blue",
      color_name_tc: "薄荷綠",
      sku: "GDV2-GB-BL-NE",
    },
    {
      colorValue: "white",
      color: "#E9E0D2",
      color_name_en: "White",
      color_name_tc: "椰子白",
      sku: "GCV2-GB-WH-NE",
    },
    {
      colorValue: "black",
      color: "#0E0E10",
      color_name_en: "Black",
      color_name_tc: "甘草黑",
      sku: "GDV2-GB-BK-NE",
    },
    {
      colorValue: "aqua",
      color: "#7CA4DB",
      color_name_en: "Aqua",
      color_name_tc: "海洋藍",
      sku: "GCV2-GB-AQ-NE",
    },
    {
      colorValue: "red",
      color: "#E4022B",
      color_name_en: "Red",
      color_name_tc: "火熱紅",
      sku: "GCV2-GB-RE-NE",
    },
  ],
};
